import { Field } from "formik";
import React from "react";
import {FieldFeedbackLabel1} from "./FieldFeedbackLabel1";

const getFieldCSSClasses = (touched, errors) => {
  const classes = ["form-control + form-control form-control-solid"];
  if (touched && errors) {
    classes.push("is-invalid");
  }

  if (touched && !errors) {
    classes.push("is-valid");
  }

  return classes.join(" ");
};

export function Input2({
  field, // { name, value, onChange, onBlur }
  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label,
  withFeedbackLabel = true,
  customFeedbackLabel,
  type = "text",
  ...props
}) {
  // console.log(field.value)
  return (
    <>
      {label && <label>Enter {label}</label>}
      <Field
        type={type}
        className={getFieldCSSClasses(touched[field.name], errors[field.name])}
        {...field}
        {...props}
        field={field}
      />
      {withFeedbackLabel && (
        field.value === "No Records" && <FieldFeedbackLabel1
          error={errors[field.name]}
          touched={touched[field.name]}
          label={label}
          type={type}
          customFeedbackLabel={customFeedbackLabel}
        />
      )}
    </>
  );
}
